// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueResource from 'vue-resource';
import Vuex from 'vuex';
import router from './router'
import store from './vuex/store';

/* DIRECTIVES */
import slideIn from './directives/slide-in.directive';
import slideUp from './directives/slide-up.directive';
import popIn from './directives/pop-in.directive';


/* FUNCTIONS */
import zoom from './functions/zoom';

/* config */
Vue.config.productionTip = false

/* USE */
Vue.use(VueResource);
Vue.use(Vuex);

Vue.http.options.root = 'https://amerisleep-cms.firebaseapp.com';
/* eslint-disable no-new */
const app = new Vue({
  router,
  store,
  // el: '#app',
  // template: '<App/>',
  // components: { App },
  directives: {
    'slide-in': slideIn,
    'slide-up': slideUp,
    'pop-in': popIn,
  },

  updated() {
    zoom(this);

  },


  mounted() {

    // Init Zoom
    zoom(this);

    // Init ScreenSaver
    this.showScreensaver();


    // The current product eg.: as1
    let product = this.$route.params.product;

    console.log('[product]', product);

    this.createManifest(product);
    // Dispatch event to get product by url parameter and save it on the store
    this.$store.dispatch('get_product_details', product);

    // Dispatch event to get product review average by url parameter and save it on the store
    this.$store.dispatch('get_product_reviews_average', product);

    // Set the ScreenSaver background based on the current product
    let bg = document.getElementById("screensaver");
    if (product) {
      bg.style.backgroundImage = "url(" + this.$store.state.product.images[product].slides[8] + ")";
    } else {
      // bg.style.backgroundImage = 'url(/s)'
    }

  },

  methods: {
    /*
      SCREENSAVER
      show screensaver if inactive
    */
    showScreensaver() {

      // The timeout
      var mousetimeout;
      // Sw interval check
      let checkSwInterval;

      // Lets reinstance 'this' so we ca use within 'document'
      let vue = this;


      // Always clean the timeout as soon as the user touch the screen
      document.addEventListener("touchstart", function (e) {

        clearTimeout(mousetimeout);
        clearInterval(checkSwInterval);
      });


      // Set the timeout as soon as the user finishes touching the screen
      document.addEventListener("touchend", function () {

        mousetimeout = setTimeout(function () {

          // Redirect to home
          vue.$router.push({ name: 'screensaver' });
          vue.forceSWupdate()

          checkSwInterval = setInterval(function () {
            vue.forceSWupdate()
          }, 1000 * 60 * 10); // 10 minutes

        }, 1000 * 60 * 6); // 6 minutes

      });

    },

    forceSWupdate() {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(function (registrations) {
          for (let registration of registrations) {
              registration.update()
            }
          })
        }
    },

    createManifest(product) {
      if (product && navigator.onLine) {
        const link = document.createElement('link');
        link.href = `/static/manifests/${product.toLowerCase()}/manifest.json`;
        link.rel = 'manifest';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
    }

  }
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js